import * as React from "react";
import Chip from "@mui/material/Chip";
import { formatDate } from '../../utils/utils';

function renderStatus(value, statuses) {
  const colors = {
    "HEAD": 'success',
    "PACK": 'success',
    "COMP": 'success',
    "UNAC": 'default',
    "ARVD": 'default',
  };
  const parsedStatus = statuses.find(s => s.id == value)?.code;
  return <Chip label={parsedStatus} color={colors[parsedStatus]} size="small" />;
}

function renderType(value, taskTypes) {
  const parsedType = taskTypes.find(s => s.id == value)?.key;
  return parsedType;
}

export const getCaseColumns = (statuses, taskTypes) => [
  { field: "id", headerName: "Task ID", flex: 1, minWidth: 120 },
  { 
    field: "typeId",
    headerName: "Task Tpe",
    flex: 1,
    minWidth: 120,
    renderCell: (params) => renderType(params.value, taskTypes),
  },
  {
    field: "createdOn",
    headerName: "Opened on",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => formatDate(params.value, true),
  },
  {
    field: "customerName",
    headerName: "Customer Name",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "statusId",
    headerName: "Status",
    flex: 1,
    minWidth: 120,
    renderCell: (params) => renderStatus(params.value, statuses),
  }
];
